import fs from 'node:fs'
import path from 'node:path'
import { fail } from '../schema-prompts/fail.js'

export function assertSchemaDoesNotExist(schemasDir: string, name: string): void {
  const rootPath = path.join(schemasDir, `${name}.json`)
  const formPath = path.join(schemasDir, 'forms', `${name}.json`)
  const existing = [rootPath, formPath].filter((filePath) => fs.existsSync(filePath))

  if (existing.length > 0) {
    fail(
      `Schema "${name}" already exists. Remove or rename the existing schema first:\n${existing.map((filePath) => `  - ${filePath}`).join('\n')}`
    )
  }
}
